// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tCSgG","col":"styles_col__3CS5z"};